export default __webpack_public_path__ + "static/works-1-e5ee811810ff8e40b072dc6b44ff4a42.png";